import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    GET_VERSION_INFO: createActionType(FULL_NAMESPACE, "GET_VERSION_INFO"),
    GET_VERSION_INFO_COMPLETED: createActionType(FULL_NAMESPACE, "GET_VERSION_INFO_COMPLETED")
};
